var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#198754"
    },
    d: "M443.5,15.099C441.7,3.1,426.7-2.001,418.001,6.7L387.1,37.599C347.5,13.599,302.5,0,256,0 C116.499,0,3.6,110.2,0,249.399c0,7.8,5.4,14.401,12.9,15.3l61,8.699c9,1.201,17.1-5.698,17.1-15 c-0.601-44.7,16.199-86.398,47.701-118.198C169.9,108.399,211.601,91,256,91c22.2,0,44.399,4.499,64.501,13.2l-29.702,29.7 c-8.699,8.699-3.6,23.699,8.401,25.499L447.7,180.7c9.899,1.5,18.6-7.2,17.1-17.1L443.5,15.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#198754"
    },
    d: "M499.1,248.5l-61-8.701c-8.1-0.899-17.1,6-17.1,16.201c0,90.899-74.099,165-165,165 c-22.2,0-44.099-4.501-64.2-13.2l28.801-28.801c8.699-8.699,3.6-23.699-8.699-25.199L63.401,332.5c-9.6-1.5-18.301,6.899-16.8,16.8 L67.9,497.8c1.501,12.299,16.501,17.401,25.201,8.699l31.8-31.8C164.5,498.399,209.5,512,256,512c138.9,0,251.8-109.6,256-248.2 C512,256,506.6,249.399,499.1,248.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#198754"
    },
    d: "M320.501,104.2C300.399,95.499,278.2,91,256,91V0c46.5,0,91.5,13.599,131.1,37.599L418.001,6.7 C426.7-2.001,441.7,3.1,443.5,15.099l21.301,148.5c1.5,9.901-7.202,18.6-17.1,17.1l-148.5-21.301 c-12.001-1.8-17.1-16.8-8.401-25.499L320.501,104.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#198754"
    },
    d: "M512,263.8C507.8,402.4,394.9,512,256,512v-91c90.901,0,165-74.101,165-165 c0-10.201,9-17.1,17.1-16.201l61,8.701C506.6,249.399,512,256,512,263.8z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.e1c7525433030869eb37e20df47f6a66.svg";
export { ForwardRef as ReactComponent };